import { serializeQuery } from "@/utils/UrlUtils";
import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiPathGroups {
  static createPathGroup(appId, pathGroup) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/path_groups`, {
      method: "POST",
      body: pathGroup,
    });
  }

  static getPathGroups(appId) {
    return apiFetch(
      `${ApiBaseUrl}apps/${appId}/path_groups?path_type=horizontal,vertical,tile,text`,
    );
  }

  static getPathGroup(appId, pathGroupId, range, filter) {
    return apiFetch(
      `${ApiBaseUrl}apps/${appId}/path_groups/${pathGroupId}?${this.getMetricPeriod(
        range,
        filter,
      )}`,
    );
  }

  static updatePathGroup(appId, pathGroup, range, filter) {
    return apiFetch(
      `${ApiBaseUrl}apps/${appId}/path_groups/${pathGroup.id}?${this.getMetricPeriod(
        range,
        filter,
      )}`,
      {
        method: "PUT",
        body: pathGroup,
      },
    );
  }

  static getMetricPeriod(range, filter) {
    if (filter === "since_start_date") filter = "last_seven_days"; // hack to disallow since_start_date for path groups but retain same key with promos
    let params;
    if (filter && filter === "custom" && range) {
      params = { metric_periods: [{ period: "custom", date_range: range }] };
    } else {
      params = { metric_periods: [{ period: filter }] };
    }

    return serializeQuery(params);
  }

  static deletePathGroup(appId, pathGroupId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/path_groups/${pathGroupId}`, {
      method: "DELETE",
    }).then(_ => pathGroupId);
  }

  static setPriority(appId, pathGroups) {
    const prioritizedList = pathGroups.reduce((h, pg) => {
      return {
        ...h,
        [pg.id]: { priority: pg.priority },
      };
    }, {});
    return apiFetch(`${ApiBaseUrl}apps/${appId}/path_groups/set_priority`, {
      method: "POST",
      body: { path_groups: prioritizedList },
    });
  }

  static getActivities(appId, pathGroupId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/path_groups/${pathGroupId}/activity`);
  }

  static getPathGroupModel(appId, pathType, deviceType) {
    return apiFetch(
      `${ApiBaseUrl}apps/${appId}/path_groups/new?path_type=${pathType}&device_type=${deviceType}`,
    );
  }
}
